import React from 'react';
import styled from 'styled-components';
import { renderHTMLString } from '../../../../../../helpers';
import { renderStyledElementStyles } from '../../../../helpers';
import { useRootSelector } from '../../../../../../store/hooks';
import { selectPageConfig } from '../../../../../../store/features/pageConfig';

export const StyledParagraph = styled.p`
  margin: 0;
  padding: 0;

  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.dStyles.elements.paragraph)}
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.vStyles.elements.paragraph)}
`;

export type ParagraphProps = {
  text?: string | null;
  className?: string;
  children?: React.ReactNode;
};

export const Paragraph = ({ text, children, className }: ParagraphProps) => {
  const pageConfig = useRootSelector(selectPageConfig);

  return (
    <StyledParagraph className={className}>
      {children || renderHTMLString(text, pageConfig?.location)}
    </StyledParagraph>
  );
};
